export const DEFAULT_CENTER = [51.3816063, 35.6993744];
export const DEFAULT_ZOOM = 11;
export const DEFAULT_SHOW_MARKER = true;
export const DEFAULT_DOUBLE_CLICK_ZOOM = false;
export const DEFAULT_SHOW_MAP_SEARCH = false;
export const DEFAULT_SCROLL_WHEEL_ZOOM = "center"; // boolean or 'center'
export const CEDAR_MAP_TOKEN = process.env.REACT_APP_CEDARMAP_TOKEN;
